module.exports = __webpack_public_path__ + "media/images/sosial_media/fb-new-full-c-e5d6062c11a2d9daf24d659a0ea6464d.png";